module.exports = __webpack_public_path__ + "img/gmp.7b0a3108.png";